import { EventType, SetPresence } from "matrix-js-sdk";
import { USER_TYPE_CLIENTS, USER_TYPE_EMPLOYEES } from "src/constants/chat";

export const generateNameInitials = (firstName, lastName) => {
    const firstNameInitial = firstName ? firstName[0].toUpperCase() : "" ;
    const lastNameInitial = lastName ? lastName[0].toUpperCase() : "" ;
    return firstNameInitial + lastNameInitial;
};
// TODO: update all other components doing capitalization

export const leftNavTrimStringWithEllipsis = (string) => {
    const length = 40;
    return trimStringWithEllipsis(string, length);
};

export const trimStringWithEllipsis = (string, length = 25) => {
    return string.length > length ? string.substring(0, length - 3) + "..." : string;
};

export const capitalizeString = (string) => {
    if (typeof string !== "string") {
        console.error("Invalid type or empty string passed to capitalizeString()");
        return string;
    }

    switch (string.length) {
    case 0:
        return "";
    case 1:
        return string.charAt(0).toUpperCase();
    default:
        return string.charAt(0).toUpperCase() + string.slice(1).toLowerCase();
    }
};

export const uppercaseWords = (string) => {
    return string.replace(/\w\S*/g, (txt) => {
        return txt.charAt(0).toUpperCase() + txt.slice(1).toLowerCase();
    });
}

export const isPositiveNumber = (value) => {
    const num = Number(value);
    return !isNaN(num) && num >= 0;
};

export const isANonEmptyString = (string) => {
    return string && string.trim() !== "";
};

export const calculatePoints = (data) => {
    if (data.length === 0) {
        return data; // Return the same array if it's empty
    }
    // Find the highest count in the array
    let newData = data.sort(function(a, b) {
        const dateA = new Date(a["date"]);
        const dateB = new Date(b["date"]);
        return dateA - dateB;
    });
    const highestCount = newData.reduce((max, obj) => (obj.value > max ? obj.value : max), newData[0].value);
    // Calculate points for each object
    newData.map(item => {
        let row = item;
        if (row.value !== 0) {
            const percentage = (row.value / highestCount) * 100;
            // Map the percentage to a point between 1 and 10
            const point = (percentage / 10) + 0.1;
            row.point = point + 1;
            return row;
        } else {
            row.point = 1;
            return row;
        }
        // item.point = point;
    });

    return newData;
};

/**
 * find and get an object from an array of objects
 * @param {array} array
 * @param {string} propertyName
 * @param {*} value
 */
export const getObjectByPropertyValue = (arrayOfObjects, propertyName, value) => {
    return arrayOfObjects.find(obj => obj[propertyName] === value);
};

export const doesObjectPropertyExist = (object, propertyName) => {
    return Object.prototype.hasOwnProperty.call(object, propertyName);
};

export const isListTypeEmployeeOrClient = (type) => {
    return [USER_TYPE_CLIENTS, USER_TYPE_EMPLOYEES].includes(type);
};


/**
 * making this a helper since this is probably going to be used in several places
 * @param {array} onlineUsers 
 * @param {string} userToCheck 
 * @returns {boolean}
 */

export const hasRoomMessages = (chat, roomEvents) => {
    const chatRoom = checkRoomForEventsFromList(chat, roomEvents);

    if (roomEvents.length === 0 || !chatRoom) {
        return false;
    }
    
    const roomMessages = chatRoom.timeline.filter((ev) => ev.type === EventType.RoomMessageEncrypted);
    return roomMessages.length > 0;
};

const checkRoomForEventsFromList = (chat, roomEvents) => {
    const chatRoom = roomEvents.find((roomEventChat) => roomEventChat.chat.matrixRoomId === chat.matrixRoomId);
    return chatRoom;
};

/**
 * @param {MatrixClient} matrixClient
 * @param {string | null} matrixUserId
 * @returns {boolean}
 */
export const isUserOnline = (matrixClient, matrixUserId) => {
    if (!matrixClient || !matrixUserId) {
        //console.warn(`User ${matrixUserId} is offline`);
        return false;
    }
    const user = matrixClient.getUser(matrixUserId);
    const val = user?.presence === SetPresence.Online || false;
    //console.warn(`User ${matrixUserId} is ${val ? "online" : "offline"}`);
    return val;
};

export const downloadUserKeysForDecryption = async (matrixClient, room) => {
    try {
        const userIds = room.getMembers().map((i) => { 
            return i.userId; 
        });
        await matrixClient.downloadKeysForUsers(userIds);
    } catch (error) {
        console.error("downloadUserKeysForDecryption error: ", error);
    }
};

export let customNames = {
    employees: "Employees",
    clients: "Clients"
};

export const setGlobalCustomNames = (clients, employees) => {
    customNames = {
        employees: employees ?? "Employees",
        clients: clients ?? "Clients"
    };
};

export let accountOwnerEmployeeName = {
    firstName: "",
    lastName: ""
};

export const setGlobalAccountOwnerEmployeeName = (firstName, lastName) => {
    accountOwnerEmployeeName = {
        firstName: firstName ?? "",
        lastName: lastName ?? ""
    };
};


/**
 * Calculate totals consistent with API
 */
export const calculateTotals = ({
    subtotalCents,
    taxFraction = 0,
    processingRate = 0.03
}) => {
    // tax-inclusive subtotal in cents
    const taxInclusiveCents = Math.round(subtotalCents * (1 + taxFraction));

    // processing fee in cents
    const processingFeeCents = Math.round((taxInclusiveCents * processingRate) / (1 - processingRate));

    // GST includes fee for AU
    const gstCents = Math.round((subtotalCents + processingFeeCents) * taxFraction);

    // Total = subtotal + fee + gst
    const totalCents = subtotalCents + processingFeeCents + gstCents;

    return {
        subTotal: subtotalCents / 100,
        gst: gstCents / 100,
        processingFee: processingFeeCents / 100,
        total: totalCents / 100
    };
};
